module.exports = __webpack_public_path__ + "static/img/code.fe63412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.jpg
// module id = d46q
// module chunks = 45